import postcodesData from "./postcodes_data.json";

export function getPostcodeCountryData(country_iso: string) {
  /** Sourced from geopostcodes.com */
  const countryData = postcodesData.find(
    (entry) => entry.ISO.toLowerCase() === country_iso.toLowerCase()
  );
  if (!countryData) {
    return null;
  }
  let countryDataRegexPattern = countryData.Regex;
  if (typeof countryDataRegexPattern === "number") {
    countryDataRegexPattern = countryDataRegexPattern.toString();
  }
  return {
    ...countryData,
    Regex: RegExp('^' + countryDataRegexPattern + '$')
  }
}

export function getPostcodeCountriesData() {
  return postcodesData;
}
